<script lang="ts" module>
  import { slide } from 'svelte/transition';
  import type { Accordion, AccordionItem } from 'melt/builders';
  import type { Snippet } from 'svelte';
  import { tv } from 'tailwind-variants';

  export type ExpandableCardItem = AccordionItem<
    {
      key: string;
    },
    false
  >['item'];

  export interface ExpandableCardProps {
    expanded?: boolean;
    content?: Snippet;
    header: Snippet;
    disabled?: boolean;
    useAccordion?: {
      accordion?: Accordion<boolean>;
      item: ExpandableCardItem;
    };
  }
</script>

<script lang="ts">
  let {
    content,
    header,
    expanded: expandedProp = $bindable(),
    disabled: disabledProp,
    ...props
  }: ExpandableCardProps = $props();

  // Styles for button
  const buttonStyle = tv({
    base: 'border-gradient rounded-md border from-border-gradient-start to-border-gradient-end px-3 py-2 ',
    variants: {
      disabled: {
        true: '',
        false: 'hocus:to-border-gradient-end-H',
      },
    },
  });
</script>

<div
  {...props.useAccordion ?
    (props.useAccordion.accordion?.getItem(props.useAccordion.item).heading ?? {})
  : {}}
  class={buttonStyle({ disabled: disabledProp })}
>
  <button
    class="flex w-full items-center gap-1"
    onclick={() => {
      // If accordion is used, this button should not control the expand/contract
      if (!disabledProp && !props.useAccordion) expandedProp = !expandedProp;
    }}
    {...props.useAccordion ?
      (props.useAccordion.accordion?.getItem(props.useAccordion.item).trigger ?? {})
    : {}}
  >
    {@render header?.()}
  </button>

  {#if expandedProp && !disabledProp && content}
    <div class="flex flex-col gap-3" transition:slide>{@render content?.()}</div>
  {/if}
</div>
